export default __webpack_public_path__ + "static/media/DNo.11-5.6bf6378b.jpg";